import Vue from 'vue'
import VueRouter from 'vue-router'
import home from '../pages/Home.vue'
/** 产品服务 */
import refactorProduct from '../pages/refactor/Product.vue'
/** 客户案例 */
import refactorCase from '../pages/refactor/Case.vue'
/** 灰鲸资讯 */
import refactorNews from '../pages/refactor/News.vue'
/** 关于我们 */
import refactorAbout from '../pages/refactor/About.vue'
/** 文章详情 */
import refactorDetails from '../pages/refactor/Details.vue'

Vue.use(VueRouter)

// 3. 配置路由规则数组
const routes = [
    {
        path: '',
        redirect: '/home'
    },
    {
        path: '/home',
        component: home
    },
	{
		path: '/refactorProduct',
		component: refactorProduct
	},
	{
		path: '/refactorCase',
		component: refactorCase
	},
	{
		path: '/refactorNews',
		component: refactorNews
	},
	{
		path: '/refactorAbout',
		component: refactorAbout
	},
    {
        path: '/refactorDetails',
        name: 'refactorDetails',
        component: refactorDetails
    }
]
// 4. 实例化VueRouter
const router = new VueRouter({
    mode: 'history',
    routes
})
router.afterEach(() => {
    window.scrollTo(0, 0);
})
// 5. 导出路由实例对象router
export default router


// WEBPACK FOOTER //
// ./src/router/index.js